import React, { useState } from "react";
import "./EventCard.scss";
import Card from "../../../../components/Card/Card";
import useEventCard from "../Card/logic/useEventCard";
import { Popconfirm, Tooltip } from "antd";
import { DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { checkUserRole } from "../../../../core/utils/helpers";
import useAuth from "../../../../core/hooks/useAuth";
import UpdateEventModal from "../../UpdateEventModal/UpdateEventModal";

function EventCard({date,image, description, title, id , eventDate, eventDescription, eventTitle, handleDeleteEvent,nameSection, cancel,includeUpcoming}) {
  const { displayDay, displayMonth, navigateToEvent, displayDayForMoData, displayMonthForMoData, } = useEventCard();
  let imgOrigin = `${process.env.REACT_APP_CORE_PATH}/images/events/${image}`;
  const { authenticatedUser } = useAuth();
  const [isModalEditOpen, setIsModaEditOpen] = useState(false);
  const handleEditClick = () => {
    setIsModaEditOpen(true);
  };
    return (
    <div className="event-card">
      <Card>
        <div
          className="card-image"
          style={{
            backgroundImage: `url(${
              imgOrigin||
              "https://www.pulsecarshalton.co.uk/wp-content/uploads/2016/08/jk-placeholder-image.jpg"
              })`,
          }}
        >
           <div className="image-modal">
            <button onClick={navigateToEvent(id)}>Preview {nameSection}</button>
          </div>
        </div>
        <div className="detail-section">
          <div className="date-section">
            <div className="month-section">
              {displayMonth(new Date(date)) || displayMonthForMoData(eventDate?.toDateString()) || "Unknown"}
            </div>
            <div className="day-section">
              {displayDay(new Date(date)) || displayDayForMoData(eventDate?.toDateString()) || "Unknown"}
            </div>
          </div>
          <div className="content-section">
            <h3 onClick={navigateToEvent(id)}>
              {title || eventTitle || "None"}
            </h3>
            <h4>{description || eventDescription || "None"}</h4>
          </div>
          { checkUserRole(authenticatedUser, ["Admin", "Trainer"],
          <div className="icons-row">
            <EditOutlined className="editIcon" onClick={handleEditClick}/>
            <UpdateEventModal
              setIsModalEditOpen={setIsModaEditOpen}
              isModalEditOpen={isModalEditOpen}
              idEvent={id}
              includeUpcoming={includeUpcoming}
            />
            <Popconfirm
              title="Delete the event"
              description="Are you sure to delete this event ?"
              onConfirm={(e) => handleDeleteEvent(id, e)}
              onCancel={(e) => cancel(e)}
              okText="Yes"
              cancelText="No"
            >
              <>
                <Tooltip placement="bottomLeft" title="Delete event">
                  <DeleteOutlined  className="trashIcon" />
                </Tooltip>
              </>
            </Popconfirm>
          </div>
              )
            }
        </div>
      </Card>
    </div>
  );
}

export default EventCard;




